import { Checkbox, FormControlLabel, FormGroup, Stack, TextField } from '@mui/material';
import React from 'react';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { RealityInput, useRealitiesDataQuery } from '../../../../../../../gql';
import { useIntl } from 'react-intl';

interface Props {
  stepIndex: number;
  activeStep: number;
  onStepComplete: () => void;
}

export const AccompanimentStep: React.FC<Props> = () => {
  const { data } = useRealitiesDataQuery();
  const { formatMessage } = useIntl();

  const { control } = useFormContext<RealityInput>();
  const accompanimentIds = useWatch({ control, name: 'accompanimentIds' });

  const availableOptions = data?.referrals;

  // Find the "Other" option (system option)
  const otherOption = availableOptions?.find((a) => a.isSystemOption);
  const isOtherSelected = otherOption && accompanimentIds?.includes(otherOption.id);

  return (
    <Stack spacing={2}>
      <Controller
        name="accompanimentIds"
        control={control}
        render={({ field }) => (
          <FormGroup>
            {availableOptions?.map((accompaniment, index) => (
              <FormControlLabel
                key={accompaniment.id}
                name={`${field.name}[${index}]`}
                control={<Checkbox checked={field.value && field.value.includes(accompaniment.id)} />}
                onChange={(e, checked) => {
                  if (checked) {
                    field.onChange([...field.value, accompaniment.id]);
                  } else {
                    field.onChange(
                      field.value.filter((item) => item !== accompaniment.id)
                    );
                  }
                }}
                label={accompaniment.name} />
            ))}
          </FormGroup>
        )}
      />

      {isOtherSelected && (
        <Controller
          name="accompanimentOtherValue"
          control={control}
          rules={{ required: formatMessage({ id: 'Please specify the other accompaniment' }) }}
          render={({ field, fieldState }) => (
            <TextField
              {...field}
              label={formatMessage({ id: 'Please specify' })}
              placeholder={formatMessage({ id: 'Describe the other accompaniment' })}
              fullWidth
              required
              error={!!fieldState.error}
              helperText={fieldState.error?.message}
            />
          )}
        />
      )}
    </Stack>
  );
};